export default {
  methods: {
    randomSize (image, index) {
      let r = Math.random()
      let or = r > 0.7 || image.orientation === 'landscape' ? 'landscape' : 'portrait'
      image.size = or
      if (index === 0) image.pos = 'left'
      return or
    },

    setPos (image, index) {
      if (this.randomList2[index - 1]) {
        // Landscape images
        if (image.size === 'landscape') {
          if (this.randomList2[index - 1].size === 'landscape' && this.randomList2[index - 1].pos === 'left') image.pos = 'right'
          if (this.randomList2[index - 1].size === 'landscape' && this.randomList2[index - 1].pos === 'right') image.pos = 'left'
          if (this.randomList2[index - 1].size === 'portrait' && this.randomList2[index - 1].pos === 'left') image.pos = 'right'
          if (this.randomList2[index - 1].size === 'portrait' && this.randomList2[index - 1].pos === 'right') image.pos = 'left'
          if (this.randomList2[index - 1].size === 'portrait' && this.randomList2[index - 1].pos === 'center') image.pos = Math.random() > 0.5 ? 'left' : 'right'
        }

        // Portrait images
        if (image.size === 'portrait') {
          if (this.randomList2[index - 1].size === 'landscape' && this.randomList2[index - 1].pos === 'left') image.pos = 'right'
          if (this.randomList2[index - 1].size === 'landscape' && this.randomList2[index - 1].pos === 'right') image.pos = 'left'
          if (this.randomList2[index - 1].size === 'portrait' && this.randomList2[index - 1].pos === 'left') image.pos = 'center'
          if (this.randomList2[index - 1].size === 'portrait' && this.randomList2[index - 1].pos === 'right') image.pos = 'center'
          if (this.randomList2[index - 1].size === 'portrait' && this.randomList2[index - 1].pos === 'center') image.pos = Math.random() > 0.5 ? 'left' : 'right'
        }
      }

      return 'pos' + image.pos
    }
  }
}
